import { brandConfiguration } from "@/brands/config";
import { useLocation } from "@aviv-unified-frontend/runtime/router";
import { getFeaturesFlags, getPreviewMode } from "@/utils";
/**
 * @internal: this hook generates the CdpConfig object based on BrandConfiguration and Classified
 *
 * @remarks: DO NOT USE it to access the Config object, use useConfig instead !
 */
export const useCdpConfig = (env, classified) => {
    const { brand, brandName, portal, urls: { oauth, assets, crsBaseUrls }, tracking: { site: trackingSite, customerActions }, } = brandConfiguration;
    const { pathname, search } = useLocation();
    return {
        env,
        brand,
        brandName,
        portal,
        trackingSite,
        customerActionEnabled: customerActions.enabled,
        oauthBaseUrl: oauth,
        featuresFlags: getFeaturesFlags(classified === null || classified === void 0 ? void 0 : classified.featureFlags, search),
        host: "",
        appVersion: process.env.APP_VERSION || "",
        mapboxToken: process.env.MAPBOX_API_TOKEN || "",
        customerActionSecrets: process.env.CUSTOMER_ACTION_SERVICE_TOKEN || "",
        geoApiToken: process.env.GEO_AUTOCOMPLETE_API_TOKEN || "",
        crsBaseUrl: crsBaseUrls[env],
        previewMode: getPreviewMode(pathname),
        search,
        sharedAssetsUrl: assets,
    };
};
